import React from 'react';
import './manifesto.css';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { IBody, IColor } from '../../../utils/types/contentful';
import { IParagraph, IImage, IVideo } from '../../../../utils/types/contentful';
import { Image } from '../../UI/Media';
import { Video } from '../../UI/Media/Video/video';
import { getContentType } from '../../UI/Elements/Body/body.utils';

export interface ManifestoProps {
  body: IBody;
  image?: IImage;
  video?: IVideo;
  color?: IColor;
}

const options = () => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <div
        className='text-3xl sm:text-4xl'
        style={{ margin: 0, lineHeight: 1.4 }}>
        <Label
          text={children}
          color={{ classname: 'gray-800' }}
        />
      </div>
    ),
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      const contentType = getContentType(node);
      if (contentType === 'ContentfulLabel') {
        return <Label {...node?.data?.target} />;
      }
    },
  },
});

export interface IBodyProps extends IParagraph {
  locale?: string;
}

export const ManifestoBody = ({ richBody }: IBodyProps) =>
  richBody ? <>{renderRichText(richBody, options())}</> : <></>;

export const Manifesto = ({
  body,
  hasIcon = { value: true },
}: ManifestoProps) => (
  <div className='flex border-t lg:border-t-0 relative justify-center items-center w-full py-20 lg:px-16'>
    {hasIcon.value && (
      <div className='flex bg-white justify-center items-center border border-primary rounded-bl-xl border-t-0 absolute top-0 right-0 p-4 citation'>
        <Icon
          iconKey='Citation'
          size='5xl'
        />
      </div>
    )}
    <div className='w-full text-center px-4 lg:px-0'>
      <ManifestoBody richBody={body.richBody} />
    </div>
  </div>
);

export const ManifestoWithImage = ({
  image,
  video,
  body,
  color,
}: ManifestoProps) => (
  <div className='relative w-full block transform top-48 -translate-y-60 lg:top-36  lg:flex '>
    <div className='w-full flex justify-center lg:w-min'>
      <div
        className={`manifesto-image w-60 h-60 md:w-80 md:h-80 lg:w-96 lg:h-96 p-0.5 bg-gradient-to-t ${
          color?.classname ? `from-${color?.classname}` : 'from-primary'
        } to-white`}>
        {image && (
          <Image
            {...image}
            heigh='100%'
            width='100%'
            objectFit='cover'
          />
        )}
        {video && (
          <Video
            {...video}
            height='100%'
            width='100%'
          />
        )}
      </div>
    </div>
    {body && (
      <div className='pt-16 flex flex-col justify-end lg:pt-0 lg:pl-16'>
        <ManifestoBody richBody={body.richBody} />
      </div>
    )}
  </div>
);
